/**
 * Closed-set string unions shared by the API, the admin editor and the signing
 * page. Each `*_S` array is the runtime list (for validators, pickers and
 * Swagger enums); the type next to it is derived from the array so the two can
 * never drift. Values mirror the Prisma enums in apps/api/prisma/schema.prisma
 * exactly — change one, change the other.
 */
/**
 * `variable` merges a value at generation time, `input` is captured from a
 * signer, `static` is fixed text baked into the template — same on every
 * document, nothing to send and nothing to sign.
 */
export const FIELD_KINDS = ['variable', 'input', 'static'];
export const INPUT_TYPES = ['signature', 'initials', 'date', 'text', 'checkbox'];
/**
 * What a library variable holds. `checkbox` merges as a mark drawn only when
 * the value is true; `text` merges the value as a string.
 *
 * A subset of InputType by design — a field's `type` always answers the same
 * question ("what does this box render as") whether it's a variable or a signer
 * input, so anything branching on it must check `kind` first.
 */
export const VARIABLE_TYPES = ['text', 'checkbox'];
/** `auto` = the calling system supplies the value; `asked` = a human answers a question at creation time. */
export const VARIABLE_SOURCES = ['auto', 'asked'];
/** How an asked TEXT variable is captured (checkboxes are always yes/no). */
export const ASK_INPUTS = ['text', 'textarea', 'number', 'choice', 'multichoice'];
export const ALIGNS = ['left', 'center', 'right'];
/** `auto` = the server stamps the finalisation date; `picker` = the signer chooses one. */
export const DATE_MODES = ['auto', 'picker'];
/**
 * Coordinate conventions the API ACCEPTS when a box is placed (BRIEF §5).
 * Every box is normalised to `ORIGIN`/`UNIT` at save time, so a frozen field
 * only ever carries those.
 */
export const BOX_ORIGINS = ['top-left', 'bottom-left'];
export const BOX_UNITS = ['pt', 'px', 'percent'];
/** The one origin a frozen field carries. */
export const ORIGIN = 'top-left';
/** The one unit a frozen field carries (PDF points). */
export const UNIT = 'pt';
export const TEMPLATE_STATUSES = ['draft', 'published', 'archived'];
export const ENVELOPE_STATUSES = [
    'sent',
    'in_progress',
    'completed',
    'declined',
    'cancelled',
    'expired',
];
export const SIGNER_STATUSES = ['pending', 'sent', 'viewed', 'completed', 'declined'];
export const ORDER_MODES = ['sequential', 'parallel'];
//# sourceMappingURL=enums.js.map